import { initSubRoutes } from '../../../../utils/router';

const RoutesImportArmeEnMasse = initSubRoutes({
    route: '/ajout-arme-en-masse/import',
    subroutes: {},
    nom: "Faire un ajout d'arme en masse",
});

export default RoutesImportArmeEnMasse;
